<template>
  <div
    class="d-flex flex-column align-center justify-center fill-height text-center"
    data-testid="segmentation-conversion-progress"
  >
    <v-progress-circular indeterminate class="mb-1" size="small" />
    <span class="text-caption">Adding segmentation…</span>
  </div>
</template>
